let isCheckoutButtonObserved = false;

const checkoutButtonCallback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.removedNodes.length) {
      mutation.removedNodes.forEach((node, index) => {
        if (node?.classList?.contains("cart__checkout-button")) {
          observeCheckoutButton();
        }
      });
    }
  }
};

function observeCheckoutButton() {
  let checkoutButton = document.querySelector(".cart__checkout-button");
  if (!checkoutButton) return;
  let clonedCheckoutButton;
  if (!document.querySelector(".cloned-checkout-button")) {
    clonedCheckoutButton = checkoutButton.cloneNode(true);
    clonedCheckoutButton.classList.add("cloned-checkout-button");
    checkoutButton.parentNode.insertBefore(
      clonedCheckoutButton,
      checkoutButton.nextSibling
    );
    checkoutButton.style.display = "none";
  } else {
    clonedCheckoutButton = document.querySelector(".cloned-checkout-button");
  }

  clonedCheckoutButton.name = "";

  if (!isCheckoutButtonObserved) {
    clonedCheckoutButton.addEventListener("click", function (e) {
      e.preventDefault();
      let parcelyApp = document.querySelector(".parcely_app");
      if (parcelyApp) {
        let parcelyAppCheckedInput = parcelyApp?.querySelector("input:checked");
        if (!parcelyAppCheckedInput) {
          alert(window.PARCELY_APP.selectMethodLabel);
        } else {
          clonedCheckoutButton.name = "stack-discounts-redirect";
          checkoutButton.click();
        }
      }
    });

    isCheckoutButtonObserved = true;
  }
}

const checkoutButtonObserver = new MutationObserver(checkoutButtonCallback);

checkoutButtonObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// eCommerce tracking

setTimeout(() => {
  const ratingLinks = document.querySelectorAll('.card__footer-price-review a.bv_main_container')
  if (ratingLinks.length) {
    ratingLinks.forEach(link => {
      link.setAttribute("data-track-productcard-click", "")
    })
  }
}, 5000)
